/* tslint:disable */
/* eslint-disable */
/**
 * Boatsetter API
 * Endpoints require an access token set via the `X-UserToken` header
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface DomesticV2MeTrackAbandonedSessionPost200Response
 */
export interface DomesticV2MeTrackAbandonedSessionPost200Response {
    /**
     * 
     * @type {string}
     * @memberof DomesticV2MeTrackAbandonedSessionPost200Response
     */
    'status'?: DomesticV2MeTrackAbandonedSessionPost200ResponseStatusEnum;
}

export const DomesticV2MeTrackAbandonedSessionPost200ResponseStatusEnum = {
    ok: 'ok'
} as const;

export type DomesticV2MeTrackAbandonedSessionPost200ResponseStatusEnum = typeof DomesticV2MeTrackAbandonedSessionPost200ResponseStatusEnum[keyof typeof DomesticV2MeTrackAbandonedSessionPost200ResponseStatusEnum];


